<template>
  <div class="reset-password-container">
    <AppLogo />
    <PageHeader>Восстановить пароль</PageHeader>

    <form @submit.prevent="savePassword">
      <InputField
          type="password"
          v-model="newPassword"
          placeholder="Новый пароль"
          v-if="!message"
      />
      <InputField
          type="password"
          v-model="confirmPassword"
          placeholder="Продублируйте новый пароль"
          v-if="!message"
      />
      <button type="submit" class="save-button" v-if="!message">Сохранить пароль</button>

      <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
      <div v-else-if="message" class="message">{{ message }}</div>

      <InstructionHelp v-if="!message">
        Минимальная длина пароля 8 символов.
      </InstructionHelp>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import AppLogo from '@/components/auth/AppLogo.vue'
import PageHeader from '@/components/auth/PageHeader.vue'
import InputField from '@/components/auth/InputField.vue'
import InstructionHelp from '@/components/auth/InstructionHelp.vue'
import {resetPassword, updateUser} from "@/utils/requests";

const token = localStorage.getItem('token')
const newPassword = ref('')
const confirmPassword = ref('')
const resetToken = ref('')
const email = ref('')

const errorMessage = ref(null)
const message = ref(null)

const router = useRouter()
const route = useRoute()

onMounted(() => {
  if (token === null) {
    resetToken.value = route.query.token || null
    email.value = route.query.email || null
  }
})

const savePassword = async () => {
  if (newPassword.value !== confirmPassword.value) {
    errorMessage.value = 'Пароли должны совпадать'
    return
  }

  if (newPassword.value.length < 8) {
    errorMessage.value = 'Пароль должен содержать минимум 8 символов'
    return
  }

  if (token === null && (resetToken.value === null || email.value === null)) {
    router.push('/login')
    return
  }

  if (token !== null) {
    try {
      const userId = JSON.parse(localStorage.getItem('userInfo'))['id']
      const response = await updateUser(userId, {
        password: newPassword.value,
        password_confirmation: confirmPassword.value
      })

      if (!response.ok) {
        throw new Error('Ошибка при выполнении запроса')
      }

      router.push('/profile')
    } catch (e) {
      console.error(e)
      errorMessage.value = 'Произошла ошибка при смене пароля'
    }
  } else {
    try {
      const response = await resetPassword({
        email: email.value,
        token: resetToken.value,
        password: newPassword.value,
        password_confirmation: confirmPassword.value
      })

      if (!response.ok) {
        throw new Error('Ошибка при выполнении запроса')
      }

      const json = await response.json()

      if (json.success) {
        errorMessage.value = null
        message.value = 'Вы успешно сбросили пароль. Перенаправляем на страницу входа через 5 секунд...'
        setTimeout(() => {
          router.push('/login')
        }, 5000)
      } else {
        errorMessage.value = json.data.message
      }
    } catch (e) {
      console.error(e)
      errorMessage.value = 'Произошла ошибка при смене пароля'
    }
  }
}
</script>

<style scoped>
.reset-password-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  max-width: 400px;
  margin: auto;
  text-align: center;
}

.save-button {
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: bold;
  width: 100%;
}

.error {
  color: red;
}

.message {
  color: green;
}
</style>
